import { USER_ROLES } from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";
import { SCHOOL_ROUTE_NAMES } from "./routeNames";

export const schoolAdminRoutes: AppRouteRecordRaw[] = [
  {
    path: "/add-school",
    name: SCHOOL_ROUTE_NAMES.CREATE,
    component: () => import("core/schools/pages/SchoolFormPage.vue"),
    meta: {
      title: "School toevoegen",
      roleRequired: [USER_ROLES.WEBMASTER],
    },
  },
  {
    path: "/edit-school/:id",
    name: SCHOOL_ROUTE_NAMES.EDIT,
    component: () => import("core/schools/pages/SchoolFormPage.vue"),
    meta: {
      title: "School beheren",
      roleRequired: [USER_ROLES.WEBMASTER],
    },
  },
];

export { SCHOOL_ROUTE_NAMES };
export type { SchoolRouteName } from "./routeNames";
